import { combineReducers } from 'redux'
import { reducer as coveragePlan } from './coverage-plan/redux'
import { reducer as documentList } from './benefit-illustration/reducer'

export const reducer = combineReducers({
  coveragePlan,
  documentList,
})
